import AbstractInfoTab from '../AbstractInfoTab';
import Input from './Input';

export default class InfoTab extends AbstractInfoTab {
    createInput() {
        this.input = new Input(this.provider, this.container);
    }

    resizeWindow() {
        this.positionInfoTab();
    }

    setCurrentElement(element) {
        this.currentElement = element;
        if (this.currentElement) {
            this.input.setElement(this.currentElement);
            this.input.show();
            this.placeholder.hide();
        } else {
            this.input.hide();
            this.placeholder.show();
        }
    }
}
